import script from "./SatelliteInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./SatelliteInfo.vue?vue&type=script&lang=ts&setup=true"

import "./SatelliteInfo.vue?vue&type=style&index=0&id=86f668ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86f668ec"]])

export default __exports__